export var MixinAnalyticalAccounts = {
  data: () => ({
    B_AnalyticalAccountsLoaded: false,
    TO_AnalyticalAccounts: [],
    TT_AnalyticalAccountsList: [],
    TT_AnalyticalAccountCodesList: [],
    L_AnalyticalAccountsSelected: 0,
    T_AnalyticalAccountsSelected: "",
    T_AnalyticalAccountCodesSelected: ""
  }),
  methods: {
    Fct_AnalyticalAccountsLoad(T_Period, B_ForceLoad = false) {
      if (!this.B_AnalyticalAccountsLoaded || B_ForceLoad) {
        var T_Token = "JWT " + this.$cookies.get("BackEndToken");
        return this.$BackEndAPI
          .get("budget/distinctAnalyticalAccounts/year/" + T_Period + "/", { headers: { Authorization: T_Token, Accept: "application/json", "Content-Type": "application/json" } })
          .then(O_Response => {
            this.TO_AnalyticalAccounts = [];
            if (O_Response.data != "") {
              this.TO_AnalyticalAccounts = O_Response.data;
            }
            this.Fct_AnalyticalAccountsLaunch();
          })
          .catch(() => {
            this.$router.push({ name: "Disconnect" });
          });
      } else {
        // or return a new resolved promise
        return Promise.resolve();
      }
    },
    Fct_AnalyticalAccountsReLoad() {
      this.B_AnalyticalAccountsLoaded = false;
      this.Fct_AnalyticalAccountsLoad();
    },
    Fct_AnalyticalAccountsLaunch() {
      this.TT_AnalyticalAccountsList = ["TOUS"];
      this.TT_AnalyticalAccountCodesList = ["all"];
      for (var L_Index = 0; L_Index < this.TO_AnalyticalAccounts.length; L_Index++) {
        var O_AnalyticalAccount = this.TO_AnalyticalAccounts[L_Index];
        this.TT_AnalyticalAccountsList.push(O_AnalyticalAccount.nom + " (" + O_AnalyticalAccount.code + ")");
        this.TT_AnalyticalAccountCodesList.push(O_AnalyticalAccount.code);
      }

      var T_AnalyticalAccountsList = JSON.stringify(this.TT_AnalyticalAccountsList);
      this.$cookies.set("AnalyticalAccountsList", T_AnalyticalAccountsList);

      var T_AnalyticalAccountCodesList = JSON.stringify(this.TT_AnalyticalAccountCodesList);
      this.$cookies.set("AnalyticalAccountCodesList", T_AnalyticalAccountCodesList);

      this.Fct_AnalyticalAccountsSelect();
      this.B_AnalyticalAccountsLoaded = true;
    },
    Fct_AnalyticalAccountsSelect() {
      var T_CookieAnalyticalAccount = "";
      if (this.$cookies.isKey("AnalyticalAccount")) {
        T_CookieAnalyticalAccount = this.$cookies.get("AnalyticalAccount");
      }

      this.L_AnalyticalAccountsSelected = 0; // default 'TOUS'
      for (var L_Index = 0; L_Index < this.TT_AnalyticalAccountsList.length; L_Index++) {
        var T_AnalyticalAccount = this.TT_AnalyticalAccountsList[L_Index];
        if (T_CookieAnalyticalAccount != "") {
          if (T_AnalyticalAccount == T_CookieAnalyticalAccount) {
            this.L_AnalyticalAccountsSelected = L_Index;
            L_Index = this.TT_AnalyticalAccountsList.length;
          }
        }
      }

      this.T_AnalyticalAccountsSelected = this.TT_AnalyticalAccountsList[this.L_AnalyticalAccountsSelected];
      this.$cookies.set("AnalyticalAccount", this.T_AnalyticalAccountsSelected);

      this.T_AnalyticalAccountCodesSelected = this.TT_AnalyticalAccountCodesList[this.L_AnalyticalAccountsSelected];
      this.$cookies.set("AnalyticalAccountCode", this.T_AnalyticalAccountCodesSelected);
    },
    Fct_AnalyticalAccountsChange(L_Selected) {
      var T_AnalyticalAccount = this.TT_AnalyticalAccountsList[L_Selected];
      this.$cookies.set("AnalyticalAccount", T_AnalyticalAccount);
      var T_AnalyticalAccountCode = this.TT_AnalyticalAccountCodesList[L_Selected];
      this.$cookies.set("AnalyticalAccountCode", T_AnalyticalAccountCode);
      //location.reload();
    },
    Fct_AnalyticalAccountsGet() {
      // récupérer la liste depuis le cookie
      this.TT_AnalyticalAccountsList = [];
      if (this.$cookies.isKey("AnalyticalAccountsList")) {
        this.TT_AnalyticalAccountsList = JSON.parse(this.$cookies.get("AnalyticalAccountsList"));
      }
      this.TT_AnalyticalAccountCodesList = [];
      if (this.$cookies.isKey("AnalyticalAccountCodesList")) {
        this.TT_AnalyticalAccountCodesList = JSON.parse(this.$cookies.get("AnalyticalAccountCodesList"));
      }
      this.Fct_AnalyticalAccountsSelect();
      this.B_AnalyticalAccountsLoaded = true;
    }
  }
};
